import { SpinnerWrapper, Circle } from './LoadingSpinner.styled';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

export default function LoadingSpinner({ size = 'md' }: LoadingSpinnerProps) {
  return (
    <SpinnerWrapper $size={size}>
      <Circle $size={size} />
    </SpinnerWrapper>
  );
}
